import React from 'react';
import NumberFormat from 'react-number-format';
import '../contents/css/cep-input.css';

export default class CepInput extends React.Component {
    render() {
        return (
            <NumberFormat
                className={'cep-input form-control' + (this.props.className ? (' ' + this.props.className) : '')}
                format='#####-###'
                defaultValue={this.props.defaultValue}
                onValueChange={this.props.onChange}
                style={this.props.style}
                name={this.props.name}
                id={this.props.id}
                key={this.props.key}
                ref={this.props.ref}
                onBlur={this.props.onBlur}
                readOnly={this.props.readOnly}
            />
        );
    }
}
